import { fromJS, Record } from "immutable";

export const userPrefConfigFromJSON = (data: Partial<IUserPrefConfigData>): UserPrefConfigRecord => {
  const record: IUserPrefConfigRecord = { ...(data as any) };

  if (data.notifications) {
    record.notifications = fromJS({ ...defaultNotificationConfigProps, ...data.notifications }) as any;
  }

  return new UserPrefConfigRecord(record);
};

export interface IUserPrefConfigRecord {
  notifications?: Map<string, any>;
  job_info_tour?: boolean;
  job_show_tour?: boolean;
  estimator_tour?: boolean;
}

export interface IUserPrefConfigData {
  notifications?: INotificationsConfigData;
  job_info_tour?: boolean;
  job_show_tour?: boolean;
  estimator_tour?: boolean;
}

export interface INotificationsConfigData {
  email: string;
  via_email: string[];
  via_sms: string[];
}

const defaultNotificationConfigProps: INotificationsConfigData = {
  email: "",
  via_email: [],
  via_sms: [],
};

const defaultUserPrefConfigProps: IUserPrefConfigRecord = {
  job_info_tour: false,
  job_show_tour: false,
  estimator_tour: false,
  notifications: fromJS(defaultNotificationConfigProps) as any,
};

export class UserPrefConfigRecord extends Record(defaultUserPrefConfigProps) implements IUserPrefConfigRecord {}
